export const dateTime = () => {
  const dt = new Date();
  const year = dt.getUTCFullYear();
  let month = dt.getUTCMonth() + 1;
  let date = dt.getUTCDate();
  let hours = dt.getUTCHours();
  let min = dt.getUTCMinutes();
  let seconds = dt.getUTCSeconds();

  if (month < 10) {
    month = "0" + month;
  }
  if (date < 10) {
    date = "0" + date;
  }
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (min < 10) {
    min = "0" + min;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return `${year}-${month}-${date} ${hours}:${min}:${seconds}`;
};
